import { getApiAuth } from '@/lib/axios';
import { AccessModel } from '../types';

export type LoginCredentialsDTO = {
  username: string;
  password: string;
};

async function loginWithEmailAndPassword(payload: LoginCredentialsDTO) {
  const api = await getApiAuth()
  return api.post<AccessModel>('/login/', payload);
}

export { loginWithEmailAndPassword };
